import { render, staticRenderFns } from "./ConfigChangeoversList.vue?vue&type=template&id=1be85c39&scoped=true&"
import script from "./ConfigChangeoversList.vue?vue&type=script&lang=js&"
export * from "./ConfigChangeoversList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigChangeoversList.vue?vue&type=style&index=0&id=1be85c39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be85c39",
  null
  
)

export default component.exports